import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleDateString("pt-BR");

export const RenewalNotice = ({ user }) => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  if (!user.expired_at || user.status !== "inactive" || user.renewal_pending) return null;

  const renew = async () => {
    try {
      await api.post("/plan/renew", { plan: "plan_associado" });
      toast.success("Reativação solicitada — pague o PIX de R$ 39,90");
      await refresh();
      navigate("/aguardando-ativacao");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <Card className="p-6 mb-6 border-rose-500/40 bg-rose-500/5" data-testid="renewal-notice">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex gap-3">
          <AlertTriangle className="h-5 w-5 text-rose-500 shrink-0 mt-0.5" />
          <div>
            <div className="font-display text-lg font-bold" data-testid="renewal-notice-title">
              Seu plano venceu em {fmt(user.expired_at)}
            </div>
            <p className="text-sm text-muted-foreground mt-1">
              Sua posição na matriz continua, mas enquanto estiver inativo você não recebe comissões: elas sobem para o
              próximo membro ativo no fechamento do mês. Após 2 meses sem renovar, o cadastro pode ser excluído.
              e não participa da compressão até reativar.
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <Button className="gold-btn hover:opacity-95" onClick={renew} data-testid="renew-btn">
            Reativar por R$ 39,90
          </Button>
        </div>
      </div>
    </Card>
  );
};

export const PlanValidity = ({ user }) => {
  if (!user.plan_expires_at || user.expired_at) return null;
  const days = Math.max(0, Math.ceil((new Date(user.plan_expires_at) - Date.now()) / 86400000));
  return (
    <div className="mt-2 text-[11px] text-muted-foreground" data-testid="plan-validity">
      Válido até <b>{fmt(user.plan_expires_at)}</b> · {days} dia{days === 1 ? "" : "s"}
    </div>
  );
};
